import { get } from '../index';

export const getRevit = () => {
  return get('/revit');
};
